<ng-container *ngIf="firstUser; else fm">
  <app-appl-pics [iframeUrl]="TCUrl" (checkedChange)="checked()"></app-appl-pics>
</ng-container>
<ng-template #fm>
  <form nz-form nzLayout="vertical" [formGroup]="form">
    <formly-form [form]="form" [model]="model" [fields]="fields"
                 [zlInjectData]="adm"
                 [zlInjectOptions]="adm"
                 [zlDisabledForm]="viewOnly"
    ></formly-form>
  </form>
  <div style="width: 100%; text-align: center">
    <ng-container *ngIf="form.dirty || form.touched">
      <button nz-button [nzLoading]="loading" nzType="primary" type="button" nzSize="large" [disabled]="form.invalid"
              (click)="save()">Submit
      </button>
      <button *ngIf="!loading" nz-button type="button" nzSize="large" (click)="back()">Back and Discard</button>
    </ng-container>
    <ng-container *ngIf="form.pristine">
      <button nz-button type="button" nzSize="large" (click)="back()">Back</button>
    </ng-container>
  </div>
</ng-template>
